import { Component, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Participantes, Person } from '../../models/participantes.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { ParticipantesService } from '../../services/participantes.service';
import { ParticipantesCombosResolver, ParticipantesResolverId } from '../../resolver/participantes.resolver';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReuniaoCanDeactivate } from '../../reuniao-can-deactivate';

@Component({
  selector: 'app-participantes-list',
  templateUrl: './participantes-list.component.html',
  styleUrls: ['./participantes-list.component.scss']
})
export class ParticipantesListComponent extends BaseFormComponent<Participantes> implements OnInit, ReuniaoCanDeactivate {

  id:number;
  currentData?: Person;
  currentType?: string;
  data:Participantes;
  filters: any;
  modalRef?: BsModalRef;
  @Input() print:boolean = false;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ParticipantesService,
    public participantesCombosResolver: ParticipantesCombosResolver,
    public participantesResolverId: ParticipantesResolverId,
    private navigation: NavigationService,
    private modalService: BsModalService,
  ) { 
    super(activatedRoute);
  }

  canDeactivate(): boolean {
    return !this.form.dirty;
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.initForm();
    this.start();
  }
  start(){
    if(this.id){
      this.participantesResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.data = data;
          this.initForm();
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error);
        }
      })
    }
    else{
      this.loaded();
    }
  }
  initForm() {
    this.form = new FormGroup({
        id: new FormControl(null),
        participant: new FormArray( this.data?.participant?.map(i => 
          this.getFormParticipant(i)) ?? []),
        participantForeign: new FormArray( this.data?.participantForeign?.map(i => 
          this.getFormParticipantForeign(i)) ?? [])
    });
    if (this.entity) {
      this.form.patchValue(this.entity);
    }
  }

  getFormParticipant (i:Person){
    var newForm = new FormGroup({
      id:new FormControl(i.id),
      user_cpf:new FormControl(i.user_cpf),
    });
    return newForm;
  }

  getFormParticipantForeign (i:Person){
    var newForm = new FormGroup({
      id:new FormControl(i.id),
      name:new FormControl(i.name),
      agency_id:new FormControl(i.agency_id),
      fone:new FormControl(i.fone),
      email:new FormControl(i.email),
      role_txt:new FormControl(i.role_txt)
    });
    return newForm;
  }

  

  get participantArray(): FormArray {
    return this.form.get('participant') as FormArray;
  }
  get participantForeignArray(): FormArray {
    return this.form.get('participantForeign') as FormArray;
  }
  
  getDataCreate() {
    return Object.assign({}, this.form.value);
  }
  
  salvar(): void {
    if (this.form.valid) {
      this.loading();
      var newData = this.getDataCreate();
      console.log(newData)
      this.myService.update(newData,newData['id']).subscribe({
        next: (res) => {
          this.msgSuccess('Participantes alterados com sucesso!');
          this.loaded();
          this.form.markAsPristine();
          this.form.markAsUntouched();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      });
    }
    else {
      this.markAsDirty();
    }
  }

  excluir(data, key){
    var index = this.form.get(key)?.value?.findIndex(d => d.id === data.id);
    var participantArray = <FormArray>this.form.get(key);
    if(index != -1){
      participantArray.removeAt(index);
      this.data[key].splice(index, 1);
    }
  }

  incluir(data, key){
    this.closeModal();
    var participantArray = this.form.get(key) as FormArray;
    if(key == 'participant'){
      participantArray.push(this.getFormParticipant(data));
      this.data.participant.push(data)
    }
    else{
      if(data.id){
        var index = participantArray?.value?.findIndex(d => d.id === data.id);
        participantArray.controls[index].patchValue(data);
        this.data.participantForeign[index] = data;

      }
      else{
        participantArray.push(this.getFormParticipantForeign(data));
        this.data.participantForeign.push(data)
      }
    }
    this.form.markAsDirty();
  }
  voltar() {
    this.navigation.back([`reuniao/reunioes`]);
  }
    
  openModal(type:string, item:Person = null) {
    this.currentData = item;
    this.currentType = type;
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.modalRef?.hide();
  }
  confirmSendMail(){
    if (this.form.dirty) {
      this.alertConfirmation(this.id,"Você tem participantes não salvos. Deseja enviar mesmo assim?").subscribe((confirmed) => {
        if (confirmed) {
          this.sendMail();
        }
      })
    }
    else{
      this.sendMail();
    }
  }
  sendMail(){
    this.loading();
    this.myService.sendMail(this.id).subscribe({
      next: (res) => {
        this.msgSuccess('Convite enviado com sucesso!');
        this.loaded();
      },
      error: (error) => {
        this.msgError(error.error.message);
        this.loaded();
      },
    });
  }

  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }
  //detecta se o formulário está manipulado e se  pessoa está atualizando a página ou saindo dela.
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: BeforeUnloadEvent): void {
    if (this.form.dirty) {
      event.preventDefault();
    }
  }
}
